const carousel = document.querySelector('.article-carousel');
if (carousel) {
  const flkty = new Flickity(carousel, {
    "prevNextButtons": false,
    "pageDots": true,
    "wrapAround": true,
    "contain": true
  });

  const leftArrow = document.querySelector('.article-carousel__arrow--left');
  if (leftArrow) {
    leftArrow.addEventListener('click', function () {
      flkty.previous();
    });
  }
  const rightArrow = document.querySelector('.article-carousel__arrow--right');
  if (rightArrow) {
    rightArrow.addEventListener('click', function () {
      flkty.next();
    });
  }
}
